module.exports = __webpack_public_path__ + "img/prem.99af84ec.png";